import { ActionEnum } from '../action.enum';

export namespace NotificationEventAction {


  export class ReloadNotifications {
    static readonly type: ActionEnum = ActionEnum.RELOAD_NOTIFICATION;

    constructor(public userId: string) {}
  }

  export class ReloadNotificationsOnPage {
    static readonly type: ActionEnum = ActionEnum.RELOAD_NOTIFICATIONS_ON_PAGE;
  }

}
